import React from 'react';
import { contains } from 'ramda';
import { func, string, arrayOf } from 'prop-types';
import MenuItem from 'material-ui/MenuItem';

import DropDownTitled from './DropDownTitled';
import { Compare } from '../constants';
import { compareDisplay } from '../utils/format';
import { Compare as ICompare } from '../models';

export const CompareSelector = ({
  labelColor,
  value,
  availableCompare,
  onChange,
  children,
  inDataSettings = false,
}) => (
  <DropDownTitled
    title="Compare To:"
    value={value}
    labelStyle={{ color: labelColor }}
    style={{ width: '200px' }}
    iconStyle={{
      fill: inDataSettings ? 'rgba(0, 0, 0, .87)' : 'rgba(255, 255, 255, 0.93)',
    }}
  >
    {[Compare.NONE, Compare.PERIOD, Compare.YEAR, Compare.RECURRING].map(
      compare => (
        <MenuItem
          key={compare}
          value={compare}
          disabled={!contains(compare, availableCompare)}
          primaryText={compareDisplay[compare]}
          onClick={() => onChange(compare)}
        />
      ),
    )}
    {children}
  </DropDownTitled>
);

CompareSelector.propTypes = {
  value: ICompare.isRequired,
  availableCompare: arrayOf(string).isRequired,
  onChange: func.isRequired,
};

export default CompareSelector;



// WEBPACK FOOTER //
// ./src/components/CompareSelector.jsx